exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-field-label{\n\ttext-align: right;\n\tfont-weight: bold;\n}\n.el-field-value{\n}\n", ""]);

// exports
